// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"43a518fc","667":"29ab695d","977":"4ce12cd1"}[chunkId] + ".chunk.js";
};